import { jsxs, jsx } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { memo, useId } from "react";
import { Nowrap } from "../Nowrap.js";
import { sizeStylesControl, inputStyles } from "./Common.js";
import { InputTip } from "./InputTip/InputTip.js";
import { Label } from "./Label.js";
import { LabelOptional } from "./LabelOptional.js";
import { spreadSx } from "../../utils/spreadSx.js";
import { inheritDataTestId } from "../../utils/dataTestId.js";
import cn from "../../external/classnames/index.js";
import { ErrorTooltip } from "./ErrorTooltip.js";
const ControlBody = memo(
  ({
    sx,
    label,
    error,
    tip,
    optional,
    className,
    disabled,
    hideTipText,
    compact = !0,
    size = "md",
    children,
    ignoreLabelHeight,
    ignoreHintHeight = !0,
    errorViewType = "below",
    ...props
  }) => {
    const id = useId(), showCompactLabel = label && compact, showFullLabel = label && !compact, hint = errorViewType === "below" || tip ? /* @__PURE__ */ jsx(
      InputTip,
      {
        size,
        hide: hideTipText,
        disabled,
        color: error ? "error" : "default",
        ignoreHeight: ignoreHintHeight,
        children: error || tip
      }
    ) : void 0, ifOnlyOptionalLabelOrNothing = !label || !compact, content = error && errorViewType === "tooltip" ? /* @__PURE__ */ jsx(ErrorTooltip, { title: error, children }) : children;
    return /* @__PURE__ */ jsxs(
      Stack,
      {
        className: cn(className, "id-field-control-body-root"),
        sx: [{ flex: "1 1 auto", minWidth: 0 }, ...spreadSx(sx)],
        "data-test-id": inheritDataTestId(props, "container"),
        children: [
          /* @__PURE__ */ jsxs(
            Stack,
            {
              sx: [
                {
                  flexDirection: "row",
                  width: "100%",
                  flexGrow: 0,
                  flexShrink: 1
                },
                sizeStylesControl.labelContainer[size]
              ],
              children: [
                showFullLabel && /* @__PURE__ */ jsx(
                  Stack,
                  {
                    justifyContent: "center",
                    sx: [sizeStylesControl.fullLabel[size]],
                    children: /* @__PURE__ */ jsx(
                      Label,
                      {
                        htmlFor: id,
                        size,
                        disabled,
                        "data-test-id": inheritDataTestId(props, "label"),
                        children: /* @__PURE__ */ jsx(Nowrap, { children: label })
                      }
                    )
                  }
                ),
                /* @__PURE__ */ jsxs(Stack, { className: "id-compact-label-body", sx: styles.noLabelBody, children: [
                  /* @__PURE__ */ jsxs(
                    Stack,
                    {
                      sx: [
                        inputStyles.labelCompact,
                        sizeStylesControl.labelCompact[size],
                        ifOnlyOptionalLabelOrNothing || ignoreLabelHeight ? { position: "absolute", bottom: "100%" } : {}
                      ],
                      children: [
                        showCompactLabel && /* @__PURE__ */ jsx(
                          Label,
                          {
                            htmlFor: id,
                            size,
                            disabled,
                            "data-test-id": inheritDataTestId(props, "label"),
                            children: /* @__PURE__ */ jsx(Nowrap, { children: label })
                          }
                        ),
                        /* @__PURE__ */ jsx(LabelOptional, { optional, disabled: !!disabled })
                      ]
                    }
                  ),
                  content,
                  !compact && hint
                ] })
              ]
            }
          ),
          compact && hint
        ]
      }
    );
  }
);
ControlBody.displayName = "ControlBody";
const styles = {
  noLabelBody: {
    flexGrow: 1,
    minWidth: 100,
    position: "relative"
  }
};
export {
  ControlBody
};
//# sourceMappingURL=ControlBody.js.map
